import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';

export const SelectInput = ({label, onChange, options, error}) => {
    return (
        <TextField
            select
            size="small"
            fullWidth
            error={error}
            label={label}
            onChange={event => onChange(event.target.value)}
            defaultValue=""
            required
            sx={{ mb: 1, mt: 1 }}
        >
            {options.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                    {option.name}
                </MenuItem>
            ))}
        </TextField>
    );
}
